import {http} from '~/services/http';

import {LOAD_INVITATION, UPDATE_INVITATION} from './types';
import {setStepsAction} from "~/redux/actions/guests";

export const loadInvitationAction = () => async (dispatch) => {

    const response = await http.get('/invitations/current');

    const invitation = response.data || null;

    dispatch({
        type: LOAD_INVITATION,
        payload: invitation
    });

    dispatch(setStepsAction(invitation ? invitation.package.steps.values : {}));
};

export const updateInvitationAction = (payload) => (dispatch) => {

    dispatch({
        type: UPDATE_INVITATION,
        payload: payload
    });
};

export const declineInvitationAction = (id, reason, otherReason = null, future = false) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    const body = {
        reason: reason,
        other_reason: otherReason,
        future: future,
    };

    const res = http.post('/invitations/' + id + '/decline', body, requestOptions);

    res.then((response) => {

        dispatch(loadInvitationAction());

        return response;
    });

    return res;
};

export const confirmInvitationAction = (id, personalData, agreeTerms=false) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    let body = personalData;
    body.agree = agreeTerms;

    const res = http.post('/invitations/' + id + '/confirm', body, requestOptions);

    res.then((response) => {

        dispatch(loadInvitationAction());

        return response;
    });

    return res;
};

export const submitInvitationAction = (id) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    const res = http.post('/invitations/' + id + '/submit', requestOptions);

    res.then((response) => {

        dispatch(loadInvitationAction());

        return response;
    });

    return res;
};

export const requestEditSubmittedRegistration = () => async (dispatch, getState) => {
    const res = http.put('/invitations/reset-current-registration');

    res.then(() => {
        dispatch(loadInvitationAction());
    })
}